var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaZurMiete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#efcca9;}.cls-3{fill:#d29b6e;}.cls-4{fill:#3b485e;}.cls-5{fill:#add47f;}.cls-6{fill:#76b72a;}.cls-7{fill:#59667c;}.cls-8{fill:#eef0f6;}.cls-9{fill:#d3d9e8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.8,
    y: 21.62,
    width: 94.4,
    height: 124.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 80,
    y: 21.62,
    width: 47.2,
    height: 124.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32.8,
    y: 135.89,
    width: 29.81,
    height: 9.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 97.39,
    y: 135.89,
    width: 29.81,
    height: 9.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.25,145.83a7.45,7.45,0,1,0-2.77-14.36,7.39,7.39,0,0,0-9.93-5,7.44,7.44,0,1,0-14.08,4.72,7.44,7.44,0,0,0,1.94,14.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.75,145.83a7.45,7.45,0,1,1,2.77-14.36,7.39,7.39,0,0,1,9.93-5,7.44,7.44,0,1,1,14.08,4.72,7.44,7.44,0,0,1-1.94,14.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 27.83,
    y: 14.17,
    width: 104.33,
    height: 9.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 62.61,
    y: 120.99,
    width: 17.39,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 80,
    y: 120.99,
    width: 17.39,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 55.16,
    y: 118.5,
    width: 49.68,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 45.22,
    y: 78.76,
    width: 9.94,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 55.16,
    y: 78.76,
    width: 9.94,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 94.9,
    y: 78.76,
    width: 9.94,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 104.84,
    y: 78.76,
    width: 9.94,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 45.22,
    y: 36.53,
    width: 9.94,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 55.16,
    y: 36.53,
    width: 9.94,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 94.9,
    y: 36.53,
    width: 9.94,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 104.84,
    y: 36.53,
    width: 9.94,
    height: 19.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 32.8,
    y: 98.63,
    width: 94.4,
    height: 9.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 32.8,
    y: 56.4,
    width: 94.4,
    height: 9.94
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaZurMiete);
export default __webpack_public_path__ + "static/media/ka_zur-miete.423665a47483cdb35dabf30ab4c7fe14.svg";
export { ForwardRef as ReactComponent };